import { useEffect, useState } from "react";

import { useApi } from "../api/useApi";
import { useAuth } from "../auth/useAuth";
import { displayVersion } from "../lib/version";

const frontendBuild = __APP_VERSION__;

export function VersionInfo() {
  const api = useApi();
  const { isAuthenticated } = useAuth();
  const [backendBuild, setBackendBuild] = useState<string | null>(null);
  const [backendUnavailable, setBackendUnavailable] = useState(false);

  useEffect(() => {
    let active = true;
    if (!isAuthenticated) {
      setBackendBuild(null);
      setBackendUnavailable(false);
      return () => {
        active = false;
      };
    }

    setBackendUnavailable(false);
    void api.getVersion()
      .then(({ version }) => {
        if (active) setBackendBuild(version);
      })
      .catch(() => {
        if (active) setBackendUnavailable(true);
      });
    return () => {
      active = false;
    };
  }, [api, isAuthenticated]);

  const backendLabel = !isAuthenticated
    ? "sign in to check"
    : backendUnavailable
      ? "unavailable"
      : backendBuild
        ? displayVersion(backendBuild)
        : "checking…";

  return (
    <p
      className="text-center text-[11px] text-muted-foreground"
      title={`Frontend build: ${frontendBuild}; backend build: ${backendBuild ?? backendLabel}`}
      data-testid="version-info"
    >
      Versions: frontend {displayVersion(frontendBuild)} · backend {backendLabel}
    </p>
  );
}
